<div class="create-dataset-modal">
  <div class="dataset-modal-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <mode-dialog-header>
      <h1 heading>Create dataset</h1>
    </mode-dialog-header>
  </div>
  <div class="content-container">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
      <p class="description">Export your pandas.DataFrame as a local dataset for use within this Report.</p>
      <div class="form-field">
        <label class="mode-label" for="datasetName">Dataset name <span>(required)</span></label>
        <input
          id="datasetName"
          type="text"
          formControlName="datasetName"
          data-test="datasetName"
          class="mode-input"
          capraAutofocus
          [class.mode-input-error]="datasetName?.errors?.invalidName || datasetName?.hasError('invalidNameKey')"
          placeholder="Untitled dataset"
          autocomplete="off"
        />
        <div class="mode-validation-error" *ngIf="datasetName?.invalid && datasetName?.touched">
          <div *ngIf="datasetName?.errors?.invalidName">Name must be 4-64 characters long</div>
          <div *ngIf="datasetName.hasError('invalidNameKey')">This name is already taken in this Report</div>
        </div>
      </div>
      <br />
      <mode-status-banner status="info" [showIcon]="false" accent="blue">
        <span class="banner-note create-dataset-name">{{ datasetName?.value || 'Untitled dataset' }}</span>
        will be added as a local dataset to this Report. When the Report or Notebook is run, the dataset will update
        automatically to reflect the latest successful data.
      </mode-status-banner>
      <div class="action-buttons">
        <div class="right-actions">
          <capra-button
            type="button"
            data-test="dataset-modal-cancel-button"
            text="Cancel"
            variant="secondary"
            color="neutral"
            (clicked)="close()"
          ></capra-button>
          <capra-button
            type="button"
            data-test="dataset-modal-create-button"
            text="Create dataset"
            color="default"
            [disabled]="!form.valid"
            (clicked)="onSubmit()"
          ></capra-button>
        </div>
      </div>
    </form>
  </div>
</div>
